export const CARPARKS = [
    {
        id: 'Civic',
        name: 'The Civic',
        url: 'https://at.govt.nz/driving-and-parking/find-parking/parking-in-central-auckland/civic-car-park'
    },
    {
        id: 'Downtown',
        name: 'Downtown',
        url: 'https://at.govt.nz/driving-and-parking/find-parking/parking-in-central-auckland/downtown-car-park'
    },
    {
        id: 'Victoria St',
        name: 'Victoria St',
        url: 'https://at.govt.nz/driving-and-parking/find-parking/parking-in-central-auckland/victoria-street-car-park'
    }
];
